var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPentagon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.01 512.01",
    viewBox: "0 0 512.01 512.01",
    style: {
      width: 30,
      height: 30
    },
    className: "shape-svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m507.804 200.28-245.333-187.414c-3.84-2.923-9.131-2.923-12.949 0l-245.334 187.414c-3.605 2.773-5.077 7.531-3.648 11.84l93.717 281.92c1.451 4.373 5.525 7.296 10.133 7.296h303.253c4.587 0 8.683-2.944 10.133-7.296l93.717-281.92c1.389-4.331-.083-9.067-3.689-11.84z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPentagon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pentagon.d0834c9b.svg";
export { ForwardRef as ReactComponent };